<template>
  <div>
    <user-loader v-if="userId" :user-id="userId" v-model="user" />
    <customer-user-dashboard v-if="isCustomerUser" />
    <client-user-dashboard v-else-if="user && isClientUser" :client-id="user.clientId" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { User } from '@/type';
import recognition from '@/auth/recognition';
import { type as accountType } from '@/iam/account';
import { getAccountType } from '@/user';
import UserLoader from '@/user/UserLoader.vue';
import CustomerUserDashboard from './customer-user/CustomerUserDashboard.vue';
import ClientUserDashboard from './client-user/ClientUserDashboard.vue';

interface Data {
  user: User|null,
}

export default defineComponent({
  components: {
    UserLoader,
    CustomerUserDashboard,
    ClientUserDashboard,
  },
  props: {
    userId: {
      type: Number,
      default(): number|null {
        return recognition.getUserId();
      },
    },
  },
  data(): Data {
    return {
      user: null,
    };
  },
  computed: {
    accountType(): number|null {
      return this.user ? getAccountType(this.user) : null;
    },
    isCustomerUser(): boolean {
      return this.accountType ? this.accountType === accountType.CUSTOMER : false;
    },
    isClientUser(): boolean {
      return this.accountType ? this.accountType === accountType.CLIENT : false;
    },
  },
  meta: {
    title: 'Dashboard',
  },
});
</script>
